import { FormTip } from 'components/form'
import PropTypes from 'prop-types'
import Form from 'react-bootstrap/Form'

export const valueChecked = (state, value) => ({ value, checked: state == value })

export const Radio = ({ value, state, ...props }) => (
	<Form.Check custom type="radio" {...props} {...valueChecked(state, value)}/>
)

Radio.propTypes = {
	name    : PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	label   : PropTypes.node.isRequired,
	id      : PropTypes.string.isRequired,
	state   : PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	value   : PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
}

/**
 * Creates a complete set of radio buttons, with `Form.Group` and `Form.Label`.
 * Kind of conflicts with {@link IconCheck} if you want icons too.
 * @param values {object} A map of `{ value: label }`
 * @param name {string}
 * @param label {string|JSX.Element}
 * @param tip {string|JSX.Element}
 * @param specificProps {object} A map of `{ value: { prop1: 123 } }`, to be applied only to a specific radiobutton
 * @param state {any}
 * @param onChange {function(event): void}
 * @param className {string} CSS class for the Form.Group wrapper
 * @param commonProps {object} Anything else to pass down to the radio buttons directly
 * @return {JSX.Element}
 * @constructor
 */
export default function RadioGroup({ values, name, label = '', tip = '', specificProps = {}, state, onChange, className = '',...commonProps }) {
	return <Form.Group className={className}>
		{label && <Form.Label>{label}:</Form.Label>}
		{Object.entries(values).map(([value, label]) => {
			return <Radio {...commonProps} {...(specificProps[value] || {})} {...{ name, state, value, onChange, label, key: value, id: `${name}-${value}` }}/>
		})}
		{tip && <FormTip>{tip}</FormTip>}
	</Form.Group>
}

RadioGroup.propTypes = {
	label   : PropTypes.string,
	name    : Radio.propTypes.name,
	onChange: Radio.propTypes.onChange,
	state   : Radio.propTypes.state,
	values  : PropTypes.objectOf(Radio.propTypes.label).isRequired,
}

